import React, { AllHTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import AccountSet from "./AccountSet";
import WithdrawalSetting from "./WithdrawalSetting";
import PasswordSet from "./PasswordSet";
import CloseAccount from "./CloseAccount";
import LoginLog from "./LoginLog";
interface SafetyCenterProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
//const { useTranslation } = Hooks;
const SafetyCenter: React.FC<SafetyCenterProps> = ({ className }) => {
  //const t = useTranslation();
  const { userInfo, notSub } = store.user;
  useEffect(() => {
    store.user.getUserInfo();
  }, []);

  return (
    <div className={cx("account_safely", className)}>
      <AccountSet userInfo={userInfo} />
      {notSub && <WithdrawalSetting />}
      {notSub && <PasswordSet />}
      {notSub && <CloseAccount />}
      <LoginLog></LoginLog>
    </div>
  );
};
export default observer(SafetyCenter);
